import React from 'react'
import { DataRow } from '../../../Card'
import { Badge } from '../../../../atoms/Badge'
import { Icon } from '../../../../atoms/Icon'
import { ExpandArrow } from '../../../../atoms/ExpandArrow'
import type { ZoneItemProps } from '../../LandSection.types'
import {
  ZoneItemContainer,
  ZoneHeader,
  ZoneHeaderContent,
  ZoneTitle,
  ZoneMeta,
  ZoneTypeChip,
  ZoneDetails,
  ZoneDetailsGrid,
} from './ZoneItem.styles'

export const ZoneItem: React.FC<ZoneItemProps> = ({
  zone,
  index,
  isExpanded,
  onToggle,
  t,
}) => {
  const formatDate = (date?: string) => {
    if (!date) return null
    try {
      return new Date(date).toLocaleDateString()
    } catch {
      return date
    }
  }

  const formatPercentage = (value?: number) => {
    if (value === undefined || value === null) return null
    return `${(value * 100).toFixed(0)}%`
  }

  const zoneName =
    zone.name || zone.plan_name || t('zones.defaultName', { number: index + 1 })

  return (
    <ZoneItemContainer $expanded={isExpanded}>
      <ZoneHeader onClick={onToggle}>
        <ZoneHeaderContent>
          <ZoneTitle>{zoneName}</ZoneTitle>
          <ZoneMeta>
            {zone.plan_type && (
              <ZoneTypeChip>
                <Badge variant="default">{zone.plan_type}</Badge>
              </ZoneTypeChip>
            )}
          </ZoneMeta>
        </ZoneHeaderContent>
        <ExpandArrow $expanded={isExpanded} direction="down" />
      </ZoneHeader>

      <ZoneDetails $expanded={isExpanded}>
        <ZoneDetailsGrid>
          {zone.plan_type && (
            <DataRow
              label={t('zones.planTypeAdoption')}
              value={`${zone.plan_type}${zone.adoption_date ? ` – ${t('zones.adopted')} ${formatDate(zone.adoption_date)}` : ''}`}
            />
          )}

          {(zone.name || zone.plan_name) && (
            <DataRow
              label={t('zones.zoneName')}
              value={zone.name || zone.plan_name}
            />
          )}

          <DataRow
            label={t('zones.buildingArea')}
            value={
              zone.building_area ? (
                <Icon name="check-circle" size="small" />
              ) : (
                t('common.notAvailable')
              )
            }
          />

          {zone.cover_area_perc !== undefined &&
            zone.cover_area_perc !== null && (
              <DataRow
                label={t('zones.coverageArea')}
                value={formatPercentage(zone.cover_area_perc)}
              />
            )}

          {zone.cos && <DataRow label={t('zones.cos')} value={zone.cos} />}

          {zone.cus && <DataRow label={t('zones.cus')} value={zone.cus} />}

          {zone.ibus && <DataRow label={t('zones.ibus')} value={zone.ibus} />}
        </ZoneDetailsGrid>
      </ZoneDetails>
    </ZoneItemContainer>
  )
}
